import { config } from "../../../utils/config";
import { getCookie } from "../../../utils/cookieHandler";

const useGeneralLogic = () => {
  const apiRoute = "general";

  // Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;

  const addRoles = [admin];
  const deleteRoles = [admin];
  const editRoles = [admin, managerRole];

  const initFields = [
    {
      name: "reservation_email_notification_receiver",
      label: "Reservation expiry notification email",
      type: "text",
      isRequired: false,
      placeholder: "e.g. billing@company.com",
      span: 3,
    },
    {
      name: "finance_email",
      label: "Finance email (billing notifications)",
      type: "text",
      isRequired: false,
      placeholder: "e.g. finance@company.com, cfo@company.com",
      span: 3,
    },
  ];

  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
  };
};

export default useGeneralLogic;
